<template>
    <div class="order-block">
        <div class="order-block__title"><span>Профиль покупателя:</span></div>
        <div class="order-block__content m-t-30">
            <fieldset class="form-group fieldset_horizontal">
                <label v-for="profile in dataList" :key="+profile.ID" class="custom-control custom-radio">
                    <input :value="+profile.ID" v-model="value" :name="inputName" type="radio"
                           class="custom-control-input">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">{{profile.NAME}}</span>
                </label>
                <label :key="0" class="custom-control custom-radio">
                    <input :value="0" v-model="value" :name="inputName" type="radio" class="custom-control-input">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">Новый профиль</span>
                </label>
            </fieldset>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'profile-select',
    props: {
      dataList: {
        type: [Object, Array],
        default () {
          return {}
        }
      },
      defaultValue: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        inputName: 'userProfile',
        value: this.defaultValue
      }
    },
    watch: {
      value: function (value) {
        this.$emit('select', value)
      },
      dataList: function (dataList) {
        if (!dataList) {
          this.value = 0
        }
      },
      defaultValue: function (newValue, oldValue) {
        this.value = newValue
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/components/order/components/ProfileSelect.vue